<template>
  <aside class="user-info-cont info-right-cont" v-if="activeUser || activeUser !== undefined">
    <header class="info-header">
      <avatar-cont :img-url="avatar"
                   @upload="saveAvatar($event)"
                   :editable="false"
                   @del="clearAvatar">
      </avatar-cont>
      <div class="header-right">
        <h3 class="name">
          {{activeUser.first_name}} <span v-if="activeUser.second_name">{{activeUser.second_name}}</span>
        </h3>
        <a :href="'tel:'+activeUser.contacts.phone"
           class="contacts-info"
           v-if="activeUser.contacts && activeUser.contacts.phone">
          {{activeUser.contacts.phone}}
        </a>
        <a :href="'mailto:'+activeUser.contacts.email" class="contacts-info"
           v-if="activeUser.contacts && activeUser.contacts.email">
          {{activeUser.contacts.email}}
        </a>
      </div>
    </header>
    <section-toggler @toggle="toggleSec($event)"
                     :justify="false"
                     :tabs="createReactLangSections"></section-toggler>
    <component :is="activeSection"
               :user="activeUser"></component>

  </aside>
</template>

<script>
  import {mapState,mapMutations,mapActions} from 'vuex'
  import avatarCont from '../../avatarCont'
  import userInfoAbout from './userInfoInfo'
  import userInfoRoles from './userInfoRoles'
  import userInfoDashboards from './userInfoDashboard'
  import userInfoThings from './userInfoThings'
  import {sectionsToggler} from "../../../mixins/utils/sectionToggler";

  export default {
    name: 'userInfo',
    mixins: [sectionsToggler],
    components: {
      avatarCont,
      userInfoAbout,
      userInfoRoles,
      userInfoDashboards,
      userInfoThings,
    },
    data() {
      return {
        avatar: '',
        avatarFile: '',
        activeSection: userInfoAbout,
        sections: []
      }
    },
    computed: {
      ...mapState({
        activeUser: state => state.users.rightInfo
      }),
      createReactLangSections() {
        return this.sections = [
          {
            id: 0,
            name: this.$t('users.about'),
            component: userInfoAbout,
            active: true
          },
          {
            id: 1,
            name: this.$t('users.table.roles'),
            component: userInfoRoles,
            active: false
          },
          // {
          //   id: 2,
          //   name: this.$t('users.dashboards'),
          //   component: userInfoDashboards,
          //   active: false
          // },
          {
            id: 3,
            name: this.$t('users.thigs'),
            component: userInfoThings,
            active: false
          }
        ]
      },
    },
    watch: {
      activeUser(val) {
        this.updateData(val)
      }
    },
    methods: {
      ...mapMutations({
        setRightInfo: 'users/SET_RIGHT_INFO',
      }),
      clearAvatar() {
        this.avatar = ''
      },
      saveAvatar($event) {
        this.avatarFile = $event
      },
      updateData(user) {
        if (this.activeUser) {
          this.avatar = user.contacts.avatar_url
        }
      },
    },
    mounted() {
      this.updateData(this.activeUser);
    }
  }
</script>

<style lang="scss" scoped>
.user-info-cont {
 // position: relative!important;
  margin-left: 35px;
  min-width: 420px;
  display: flex;
  height: calc(100% - 30px - 120px);
  flex-direction: column;
}

 .user-info-cont .info-header {
    display: flex;
    align-items: flex-start;
    margin-bottom: 40px;
  }

  .name {
    font-family: $msb;
    font-size: 14px;
    letter-spacing: .25px;
    margin-bottom: 10px;
  }

  .contacts-info {
    font-family: $mm;
    font-size: 14px;
    letter-spacing: .25px;
    color: $darkBlue;
    margin-bottom: 7px;
  }

  .header-right {
    margin-top: 10px;
    margin-left: 30px;
  }

.section-toggler {
  margin-bottom: 0;
}
</style>
